import { createAction } from 'util/redux-tools';
import constants from './constants';

export const resetActionStatus = createAction(constants.reset);
